export default __webpack_public_path__ + "static/media/underConstruction.db4c7aec.png";